import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useI18n } from "@/context/I18nContext";

export const FAQ_GROUPS = {
  schools: ["what", "pilot90", "whoApply", "verified", "createClass", "studentsJoin", "roles", "continuation"],
  privacy: ["teacherSee", "teacherCant", "friendJournal", "personalVocab"],
  students: ["joinWhat", "personalAccount", "findClass", "findAssignments", "inviteLink", "multiClass", "leaveData"],
  pilot: ["pilotEnds", "finishAfter", "dataAfter", "studentPilotEnds"],
};

// Canonical Education Q&A; pages pick the groups relevant to the reader.
export default function EducationFAQ({ groups = Object.keys(FAQ_GROUPS), testid = "education-faq" }) {
  const { t } = useI18n();
  return (
    <div className="space-y-6" data-testid={testid}>
      {groups.map((g) => (
        <section key={g} data-testid={`faq-group-${g}`}>
          <h3 className="font-cabinet font-bold text-lg">{t(`edu.faq.g.${g}`)}</h3>
          <Accordion type="multiple" className="mt-1">
            {FAQ_GROUPS[g].map((id) => (
              <AccordionItem key={id} value={id} className="border-b-2 border-ink/10">
                <AccordionTrigger className="text-start text-sm font-bold hover:no-underline" data-testid={`faq-q-${id}`}>{t(`edu.faq.${id}.q`)}</AccordionTrigger>
                <AccordionContent className="text-sm text-gray-700 leading-relaxed" data-testid={`faq-a-${id}`}>{t(`edu.faq.${id}.a`)}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </section>
      ))}
    </div>
  );
}
